module.exports = __webpack_public_path__ + "img/gend2_en.05a97ee.png";